<script setup lang="ts">
import { HealthMode } from '@/types';
import BaseHealthRatio from './BaseHealthRatio.vue';
import BaseHealthFactor from './BaseHealthFactor.vue';
import { useAppStore } from '@/store/app';
import { healthRatioToHealthFactor } from '@sonarwatch/portfolio-core';
const store = useAppStore();

const props = defineProps<{
  healthRatio: number | null;
}>();
const color =
  props.healthRatio === null
    ? `text-red-${store.isDark ? 'lighten' : 'darken'}-1`
    : props.healthRatio < 0.666666
    ? props.healthRatio < 0.2
      ? `text-red-${store.isDark ? 'lighten' : 'darken'}-1`
      : `text-orange-${store.isDark ? 'lighten' : 'darken'}-1`
    : `text-green-${store.isDark ? 'lighten' : 'darken'}-1`;
const ratioTooltipText =
  'If the health ratio goes to 0% or below, the liquidation of your collateral might be triggered.';
const factorTooltipText =
  'If the health factor goes to 1 or below, the liquidation of your collateral might be triggered.';
</script>

<template>
  <div v-if="healthRatio !== null">
    <span @click="store.toggleHealthMode" style="cursor: pointer">
      Health {{ store.healthMode }}:
      <span :class="color" class="font-family-mono">
        <BaseHealthRatio
          v-if="store.healthMode === HealthMode.ratio"
          :ratio="healthRatio"
        ></BaseHealthRatio>
        <BaseHealthFactor
          v-else
          :factor="healthRatioToHealthFactor(healthRatio)!"
        ></BaseHealthFactor>
      </span>
    </span>
    <v-tooltip
      :text="
        store.healthMode === HealthMode.ratio
          ? ratioTooltipText
          : factorTooltipText
      "
      content-class="text-caption"
      width="170px"
      location="top"
    >
      <template v-slot:activator="{ props }">
        <v-icon
          v-bind="props"
          class="ml-1"
          size="x-small"
          icon="mdi-information"
        ></v-icon>
      </template>
    </v-tooltip>
  </div>
</template>
